import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";

export default function Footer(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-dark"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px",
					borderTop: "1px solid var(--secondaryColor)"
				}}
			>
				<div className="container">
					<div className="row">
						
						<div className="col-md-4">
							<h6
								className="main-section-title"
							>
								Useful Links
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "",
									})
								}}
								className="btn font-bold text-light"
							>
								Home
							</h6>

							
							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "about_us",
									})
								}}
								className="font-bold text-light"
							>
								About Us
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "services",
									})
								}}
								className="font-bold text-light"
							>
								Services
							</h6>


							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "contact_us",
									})
								}}
								className="font-bold text-light"
							>
								Contact Us
							</h6>
						</div>

						<div className="col-md-4">
							<h6
								className="main-section-title"
							>
								Addresses
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
								}}
								
								className="font-bold text-light"
							>
								<MdLocationPin
									style={{
										display: "block"
									}}
									className="text-light"
									size={32}
								/>
								Jiezhi Tech Company Limited Unit 02, 21/F, Hip Kwan Commercial Building, 38 Pitt Street, Yau Ma Tei, Kowloon, Hong Kong
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
								}}
							
								className="font-bold text-light"
							>
								<MdLocationPin
									style={{
										display: "block"
									}}
									className="text-light"
									size={32}
								/>
								Guangzhou Jiezhi Trading Co. Ltd E201 Zhihuigu Investment Centre, No. 363 Huangshi West Road, Baiyun District, Guangzhou City, Guangdong Province
							</h6>

							
						</div>

						<div className="col-md-4">
							<h6
								className="main-section-title"
							>
								Reach Out
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
								}}
								className="font-bold text-light"
							>
								Email: <span>sales@jiezhitec.com</span> <br/>
							</h6>

							
						</div>

						<div className="col-md-12 text-center font-bold">
							<hr/>
							<h6
								style={{
									fontSize: "14px",
									paddingTop: "30px"
								}}
								className="text-light"
							>
								&copy;Jiezhi Tech LTD - {getCurrentYear()}
							</h6>

						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}